import * as types from '../types'

const state = {
  chargeTree: [],
  selectedCharge: {},
  casePickType: ''
}

const actions = {
  setChargeTree ({ commit }, value) {
    commit(types.CHARGETREE, value)
  },
  setSelectedCharge ({ commit }, value) {
    commit(types.SELECTEDCHARGE, value)
  },
  setCasePickType ({ commit }, value) {
    commit(types.SETCASEPICKTYPE, value)
  }
}

const getters = {
  chargeTree: state => state.chargeTree,
  selectedCharge: state => state.selectedCharge,
  casePickType: state => state.casePickType
}

const mutations = {
  [types.CHARGETREE] (state, res) {
    state.chargeTree = res
  },
  [types.SELECTEDCHARGE] (state, res) {
    state.selectedCharge = res
  },
  [types.SETCASEPICKTYPE] (state, res) {
    state.casePickType = res
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/mine.js